import { AssetsLoader } from '@dealstack/frontend/shared/components/AssetsLoader/AssetsLoader';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { ButtonsCenter } from '@dealstack/frontend/shared/components/fundament/Button/ButtonLayouts';
import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';

import { memo } from 'react';
import styled from 'styled-components';

interface ManageMipContent {
	info: string;
	warning: string;
	buttonText: string;
}

interface Props {
	onClose: () => void;
	onSubmit: () => void;
	isInProgress: boolean;
	content: ManageMipContent;
	className?: string;
	secondaryButton?: JSX.Element;
}

const ManageMipConfirmationModal = ({
	onClose,
	onSubmit,
	isInProgress,
	content,
	className,
	secondaryButton,
}: Props) => {
	return (
		<Modal
			reactModalProps={{
				shouldCloseOnOverlayClick: !isInProgress,
			}}
			onClose={onClose}
			className={className}
		>
			{isInProgress ? <InlineLoader /> : null}
			<AssetWrapper>
				<AssetsLoader src="/context/admin/mip-manage/attention.png" />
			</AssetWrapper>

			<SectionHeader size="h4b" title="Are you sure?" />

			<BodyText colorFaded variant="p-md">
				{content.info}
			</BodyText>
			<WarningText colorError bold variant="p-md">
				{content.warning}
			</WarningText>
			<ButtonsCenter>
				<Button onClick={onSubmit} iconPlacement="left" variant="delete">
					{content.buttonText}
				</Button>
				{secondaryButton}
			</ButtonsCenter>
		</Modal>
	);
};

const AssetWrapper = styled.div`
	margin-bottom: 1em;
`;
const BodyText = styled(Text)`
	margin-bottom: 0.2em;
`;

const WarningText = styled(Text)``;

const Memoized = memo(ManageMipConfirmationModal);
const Styled = styled(Memoized)`
	width: 38rem;
	text-align: center;

	${SectionHeader} {
		& > * {
			justify-content: center;
		}
	}

	${ButtonsCenter} {
		margin-top: 1.5em;
	}
`;

export { Styled as ManageMipConfirmationModal };
